import Skeleton from '@mui/material/Skeleton';

import { sxStyles, StyledCardWrap } from './CertificationCard.styles';

export const CertificationCardSkeleton = () => {
  return (
    <StyledCardWrap>
      <Skeleton sx={sxStyles.icon} variant="rounded" width={24} height={24} />

      <Skeleton variant="rounded" height={22} width="65%" />
    </StyledCardWrap>
  );
};
